import React from 'react'
import { Link } from 'react-router-dom'

export const DynamicLink = ({ children, isActive = true, ...rest }) => {
  return isActive ? <Link {...rest}>{children}</Link> : <span {...rest}>{children}</span>
}

export default DynamicLink
